<template>
  <div id="app">
    <b-navbar id="main-nav" toggleable="md" type="dark" class="default-nav">

      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

      <b-navbar-brand href="#/">
        <Logo height="48px" :organisationId="organisationId" />
      </b-navbar-brand>

      <b-collapse is-nav id="nav_collapse">

        <b-navbar-nav>
          <b-nav-item v-if="loggedIn" :to="'/activity'">Dashboard</b-nav-item>
          <b-nav-item v-if="canManageOwnPasses" :to="'/passes'">Passes</b-nav-item>
          <b-nav-item v-if="canManageOwnPasses" :to="'/passtypes'">Pass Types</b-nav-item>
          <b-nav-item v-if="canManageOwnPasses" :to="'/users'">Users</b-nav-item>
          
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <!-- <span v-if="!loggedIn" style="margin-right: 10px;color: white;font-weight: 500;font-size: 20px;">Mt Dobson</span> -->
          <b-nav-item-dropdown right  v-if="loggedIn">
            <!-- Using button-content slot -->
            <template slot="button-content">
              <em>{{userFullName}}</em>
            </template>
            <b-dropdown-item :to="'/logout'">Signout</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

      </b-collapse>
    </b-navbar>

    <b-container style="padding-top:1em;" fluid>
      <router-view/>
    </b-container>

  </div>
</template>

<script>
import Pass from "./components/Pass"
import Logo from "./components/Logo"
import Login from "./components/Login"
import Spinner from "./components/common/Spinner"

import api from "./api"
import Vue from "vue"
import Vuelidate from "vuelidate";
import BootstrapVue from "bootstrap-vue"
import {ServerTable, ClientTable, Events} from 'vue-tables-2';

import VueRangedatePicker from 'vue-rangedate-picker'
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import "vue-multiselect/dist/vue-multiselect.min.css"
import constants from './constants'

Vue.use(Vuelidate)
Vue.use(BootstrapVue)
Vue.use(ClientTable);
Vue.use(ServerTable);
Vue.use(VueRangedatePicker)

export default {
  name: "App",
  components: {
    Pass,
    Logo,
    Login,
    Spinner
  },
  data() {
    return {
      loggedIn: api.loggedIn(),
      userFullName: api.userFullName(),
      isAdmin: api.userIsAdmin(),
      canManageOwnPasses: api.canManageOwnPasses(),
      organisationId: api.getUserOrganisationId()
    };
  },
  created() {
    var that = this;
    api.onAuthChange = loggedIn => {
      this.updateUserData();
      
      if(!loggedIn && !/set_password/.test(that.$router.history.current.path)) {
        that.$router.replace('/login')
      }
    };

    const orgId = this.$route.query.organisation_id;
    if (orgId) {
      localStorage.setItem('user_organisation_id', orgId);
      if (!sessionStorage.getItem("orgReloadTriggered")) {
        sessionStorage.setItem("orgReloadTriggered", "true");
        window.location.reload();
      }
    }
  },
  methods: {
    goBack () {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
    },
    updateUserData() {
      this.loggedIn = api.loggedIn();
      this.userFullName = api.userFullName();
      this.isAdmin = api.userIsAdmin();
      this.canManageOwnPasses = api.canManageOwnPasses();
    }
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Libre+Barcode+39+Extended&display=swap');


#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
#main-nav {
  padding: 0;
}

.default-nav {
  background-color: #35A9CE;
}

.mtdobson-nav {
  background-color: #6c757d;
}

#main-nav .navbar-brand {
  padding: 0.4em;
  background: #333;
  box-shadow: #333 0 0.3em 0;
  margin-left: 0.5em;
}

#app .table th, #app .table td {
  padding: 0.25rem;
}

#app  .VueTables__search-field label {
  display:none;
}

#app .btn-primary
{
  background-color: #35A9CE;
  border-color: #35A9CE;
}


#app  .multiselect .multiselect__tag   {
  background-color: #35A9CE;
}

#app .multiselect .multiselect__tag-icon:hover  {
  background-color: rgb(43, 131, 160);
}
</style>



// WEBPACK FOOTER //
// src/App.vue